<template lang="pug">
.mainbody
    BaseSidebar
        SampleVerticalLinks
    main.mainbox
        .w-full.sticky.top-0.left-0.z-5
            BaseNavbar(
                v-if="$slots.sidebar && navbar && !$slots.navbar"
                :title="title"
                sidebar
            )
                template(#sidebar)
                    slot(name="sidebar")

            BaseNavbar(
                v-else-if="!$slots.sidebar && navbar && !$slots.navbar"
                :title="title"
            )
                template(#right)
                    slot(name="right")

            slot(name="navbar")

        .fullpage.overflow-hidden.flex.sticky.top-0.left-0.z-1(
            ref="fullpage"
            v-if="$slots.sidebar"
        )

            .flex.border-r.sticky.overflow-x-hidden.flex-col.top-0.left-0.overflow-y-auto.hidden(
                class="sm:block"
                ref="fullpage2"
                :class="{'w-14': storeCT.sidebarCtValue === 'sm', 'min-w-56': storeCT.sidebarCtValue === 'md'}"
            )
                .flex.flex-grow.h-full.flex-col
                    .flex-1
                        slot(name="sidebar")
                    .flex.px-2
                        .flex.flex-1.items-center.py-2
                            UButton.cursor-pointer.transition-all.duration-300(
                                :class="{'justify-start': storeCT.sidebarCtValue === 'md', 'justify-center': storeCT.sidebarCtValue === 'sm'}"
                                block
                                size="sm"
                                color="secondary"
                                variant="ghost"
                                :icon="storeCT.sidebarCtValue === 'md' ? 'lucide:arrow-left-from-line' : 'lucide:arrow-right-from-line'"
                                :label="storeCT.sidebarCtValue === 'md' ? 'Collapse' : ''"
                                @click="storeCT.sidebarCt = storeCT.sidebarCtValue === 'md' ? 'sm' : 'md'"
                            )

            .sticky.overflow-x-hidden.flex.flex-1.top-0.left-0.overflow-y-auto
                .flex.flex-1.flex-col.overflow-x-auto
                    slot(name="default")

                BaseRightSide(
                    v-if="$slots.rightside"
                )
                    slot(name="rightside")

        .sticky.overflow-x-hidden.flex.flex-1.top-0.left-0.overflow-y-auto(
            v-else
            ref="fullpage"
        )
            .flex.flex-1.flex-col.overflow-x-auto
                slot

            BaseRightSide(
                v-if="$slots.rightside"
            )
                slot(
                    name="rightside"
                )

    ClientOnly
        UModal(
            :close="false"
            :dismissible="false"
            v-model:open="ceklogin"
            title="Session Expired"
            description="Your session has expired. Please login again."
        )
            template(#body)
                UButton(
                    block
                    size="lg"
                    color="primary"
                    label="Logout"
                    to="/logout"
                )
</template>
<script setup lang="ts">
import { useTemplateStore } from "../stores/templateStore";
defineProps<{
  title?: string;
  navbar?: boolean;
}>();
const auth = useState("auth");
const ceklogin = ref(true);
const storeCT = useTemplateStore();
const fullpage = ref<HTMLElement | null>(null);
const fullpage2 = ref<HTMLElement | null>(null);

onMounted(() => {
  if (fullpage && fullpage.value) {
    const rect = computed(() => fullpage.value?.getBoundingClientRect().top);
    fullpage.value!.style.height = `calc(100vh - ${rect.value}px)`;
  }
  if (fullpage2 && fullpage2.value) {
    const rect2 = computed(() => fullpage2.value?.getBoundingClientRect().top);
    fullpage2.value!.style.height = `calc(100vh - ${rect2.value}px)`;
  }
});

// onMounted(() => {
//   // const storedSize = storeCT.sidebarCtValue
//   // storeCT.$subscribe((mutation, state) => {
//   //     // storeCT.sidebarCt = state.sidebarCtValue
//   // })
// });
const { $fcm } = useNuxtApp();
await callOnce(async () => {
  const { data } = await RFetch(`/system/auth/me`);
  if (data) {
    $fcm.requestPermission();
    useState("auth", () => data);
    if (data.id) {
      ceklogin.value = false;
    } else {
      ceklogin.value = true;
    }
  }
});

onMounted(() => {
  if (auth.value?.id) {
    ceklogin.value = false;
  } else {
    ceklogin.value = true;
  }
});
</script>
